var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoLayerBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 53,
    viewBox: "0 0 470 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448.943 45.2178C454.756 50.2373 462.18 53 469.861 53H0.138672C7.82031 53 15.2441 50.2373 21.0566 45.2178L64.127 8.0166C70.1074 2.85156 77.8125 0 85.793 0H384.207C392.186 0 399.893 2.85059 405.873 8.0166L448.943 45.2178Z",
    fill: "#170C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLayerBottom);
export default __webpack_public_path__ + "static/media/video_layer_bottom.c8b8876715307c9b6a15d0439e11f20c.svg";
export { ForwardRef as ReactComponent };